export default __webpack_public_path__ + "static/media/information--bus-lane-straight--g1.4a1a0ce3.png";